<template>
  <div id="qrCode">
    <div id='code'></div>
    <canvas width="150px" :id="id"></canvas>
  </div>
</template>
<style></style>
<script>
  import QRCode from 'qrcode';

  export default {
    name: 'QRCode',

    data() {
      return {
        // msg: 'hello vue',
        // codes:''
        id: `canvas${this.msg}`,
      };
    },

    props: {
      msg: String,
    },

    methods: {
      useqrcode() {
        const canvas = document.getElementById(this.id);
        // let url = 'https://explorer.v.systems/nodeInfo/' + this.msg;
        const url = {
          api: 1,
          amount: 0,
          opc: 'account',
          protocol: 'v.systems',
          address: this.msg,
        };
        QRCode.toCanvas(canvas, JSON.stringify(url), {
                        width: 200,
                        margin: 0,
                    }, (error) => {
          if (error) console.error(error);
          // console.log('QRCode success!');
        });
      },
    },

    mounted() {
      this.useqrcode();
    },
  };
</script>
